export default "/_next/static/fonts/tt_norms_pro_black_italic-7a40619ef38d3448d46b05d1e4881c1d.woff";